export default {
  'channelOnboarding.back': 'Volver',
  'channelOnboarding.description': 'Alta unificada de actores comerciales en una sola transacción.',

  'channelOnboarding.fields.entityType': 'Tipo de registro',
  'channelOnboarding.fields.automyPlan': 'Plan AUTOMY',
  'channelOnboarding.fields.billingMode': 'Modo de cobro',
  'channelOnboarding.fields.identity': 'Identidad fiscal / ID',
  'channelOnboarding.sections.companyData': 'Datos de la empresa',
  'channelOnboarding.sections.ownerUser': 'Administrador principal',
  'channelOnboarding.fields.ownerUser.lastNames': 'Apellidos',
  'channelOnboarding.fields.ownerUser.invitationHint':
    'Si el registro se completa, se enviará una invitación de activación a este correo. Si queda pendiente de AUTOMY, no hay invitación hasta que se apruebe.',

  'channelOnboarding.steps.entityType.title': 'Tipo de registro',
  'channelOnboarding.steps.entityType.hint':
    'Elija el tipo de actor. Los campos y validaciones cambian según su selección.',
  'channelOnboarding.steps.plan.title': 'Plan AUTOMY',
  'channelOnboarding.steps.plan.hint':
    'Seleccione un plan activo para la empresa que se creará. La suscripción de facturación se genera automáticamente.',
  'channelOnboarding.steps.plan.billingModeHint':
    'El plan define precio y funcionalidades. El modo de cobro define cómo se activará la suscripción de esta empresa.',
  'channelOnboarding.steps.company.title': 'Empresa',
  'channelOnboarding.steps.actor.title': 'Actor de canal',
  'channelOnboarding.steps.agreement.title': 'Acuerdo comercial',
  'channelOnboarding.steps.agreement.hint':
    'Solo se listan acuerdos aprobados. El acuerdo es obligatorio. Si no hay acuerdos aprobados, cree uno o espere la revisión de AUTOMY.',
  'channelOnboarding.steps.billing.title': 'Facturación',
  'channelOnboarding.steps.billing.hint':
    'Datos fiscales y de contacto opcionales para la suscripción de facturación.',
  'channelOnboarding.steps.billing.hintManualInvoice':
    'Con facturación manual, la razón social, la identificación fiscal y el email de facturación son obligatorios.',
  'channelOnboarding.steps.summary.title': 'Resumen',

  'channelOnboarding.fields.canCreateDistributors': 'Puede crear distribuidores',
  'channelOnboarding.fields.parentActorKind': 'Tipo de padre comercial',
  'channelOnboarding.fields.parentActorKind.hint':
    'Si no elige un padre, este actor no quedará debajo de nadie. Puede asignarle un padre de un nivel más alto, por ejemplo un Distribuidor para un Reseller.',
  'channelOnboarding.fields.parentActorCompanyId': 'Empresa padre',

  'channelOnboarding.actions.confirmRegister': 'Confirmar registro',
  'channelOnboarding.actions.registerAnother': 'Registrar otro actor',

  'channelOnboarding.registrationSummary.title': 'Registro completado',
  'channelOnboarding.registrationSummary.subtitle':
    'La empresa se creó correctamente. Revise el resumen consolidado del registro.',
  'channelOnboarding.registrationPending.title': 'En revisión AUTOMY',
  'channelOnboarding.registrationPending.subtitle':
    'Este registro está pendiente de aprobación de AUTOMY. Todavía no se envió la invitación ni se habilitó el acceso.',
  'channelOnboarding.registrationPending.approvalRequestId': 'Solicitud de aprobación: {id}',
  'channelOnboarding.registrationRejected.title': 'Registro rechazado',
  'channelOnboarding.registrationRejected.subtitle':
    'Este registro fue rechazado por AUTOMY. No se envió la invitación ni se habilitó el acceso.',
  'channelOnboarding.registrationSummary.loadError':
    'No se pudo cargar el resumen del registro. Intente nuevamente.',
  'channelOnboarding.registrationSummary.sections.company': 'Empresa',
  'channelOnboarding.registrationSummary.sections.channelProfile': 'Perfil comercial',
  'channelOnboarding.registrationSummary.sections.channelEntity': 'Actor de canal',
  'channelOnboarding.registrationSummary.sections.billingSubscription':
    'Suscripción de facturación',
  'channelOnboarding.registrationSummary.sections.aiBillingProfile': 'Facturación de IA',
  'channelOnboarding.registrationSummary.sections.defaultEnvironment': 'Entorno por defecto',
  'channelOnboarding.registrationSummary.fields.agreementId': 'Acuerdo comercial',
  'channelOnboarding.registrationSummary.fields.budgetEnabled': 'Presupuesto habilitado',
  'channelOnboarding.registrationSummary.fields.environmentType': 'Tipo de entorno',
  'channelOnboarding.registrationSummary.fields.isDefault': 'Por defecto',
  'channelOnboarding.registrationSummary.fields.isPublic': 'Público',

  'channelOnboarding.progress.title': 'Progreso del registro',
  'channelOnboarding.step.inProgress': 'En curso',

  'channelOnboarding.errors.selectEntityTypeFirst': 'Seleccione primero un tipo de registro.',
  'channelOnboarding.errors.duplicateIdentity': 'Esta identidad ya está en uso.',
  'channelOnboarding.errors.planNotAllowedForActor':
    'El plan seleccionado no está permitido para este tipo de actor.',
  'channelOnboarding.errors.parentActorPairIncomplete':
    'Indique el tipo y la empresa padre, o deje ambos vacíos.',
  'channelOnboarding.errors.noRegistrationOptions':
    'No hay tipos de registro disponibles para la empresa activa.',
  'channelOnboarding.sections.actorsWithEntity': 'Actores de canal',
  'channelOnboarding.sections.actorsWithoutEntity': 'Actores sin entidad de canal',
  'channelOnboarding.summary.operatingCompany': 'Empresa operadora',
  'channelOnboarding.summary.invitation': 'Invitación',
  'channelOnboarding.summary.parentActorNone': 'No queda debajo de nadie',
};
